import styled from 'styled-components';
import { CollapseArrow } from 'ia-react-core';

export const StyledCollapseArrow = styled(CollapseArrow)`
  position: absolute;
  top: 50%;
  margin-top:-12px;
  right: 7px;
  
  color: ${({ theme }) => theme.colors.blue5};
    &:hover {
    color: ${({ theme }) => theme.colors.blue10};
  }

  &:active {
    color: ${({ theme }) => theme.colors.blue3};
  }
`;
